
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"46","height":"38","rx":"9","stroke":"#74DBB5","stroke-width":"2"}}),_c('path',{attrs:{"d":"M22.13 31H15v-9l2.306-1.42A4.308 4.308 0 0123.5 22.5l.979 5.871c.014.086.021.173.021.26A2.37 2.37 0 0122.13 31z","fill":"#74DBB5"}}),_c('path',{attrs:{"d":"M8.37 31h7.13v-9l-2.306-1.42A4.308 4.308 0 007 22.5l-.979 5.871a1.579 1.579 0 00-.021.26A2.37 2.37 0 008.37 31z","fill":"#74DBB5"}}),_c('circle',{attrs:{"cx":"15","cy":"15","r":"5","fill":"#74DBB5"}}),_c('rect',{attrs:{"x":"26","y":"14","width":"16","height":"3","rx":"1.5","fill":"#74DBB5"}}),_c('rect',{attrs:{"x":"26","y":"19","width":"13","height":"3","rx":"1.5","fill":"#74DBB5"}}),_c('rect',{attrs:{"x":"26","y":"24","width":"16","height":"3","rx":"1.5","fill":"#74DBB5"}})])
          )
        }
      }
    